/** Guardas transitórias de panes montados; nunca persistir callbacks. */
const guards = new Map<string, { isDirty: () => boolean; onDiscard?: () => void; blockClose?: () => string | null }>();

const beforeUnload = (event: BeforeUnloadEvent) => {
  if (!Array.from(guards.values()).some((guard) => guard.isDirty())) return;
  event.preventDefault();
  event.returnValue = '';
};
let listening = false;

export function registerTabCloseGuard(path: string, isDirty: () => boolean, onDiscard?: () => void, blockClose?: () => string | null): () => void {
  const guard = { isDirty, onDiscard, blockClose };
  guards.set(path, guard);
  if (!listening) {
    window.addEventListener('beforeunload', beforeUnload);
    listening = true;
  }
  return () => {
    if (guards.get(path) === guard) guards.delete(path);
    if (!guards.size && listening) {
      window.removeEventListener('beforeunload', beforeUnload);
      listening = false;
    }
  };
}

export function isTabCloseProtected(path: string): boolean {
  return guards.get(path)?.isDirty() ?? false;
}

export function confirmTabClosures(paths: string[]): boolean {
  const blocked = paths.map((path) => guards.get(path)?.blockClose?.()).find(Boolean);
  if (blocked) { window.alert(blocked); return false; }
  const dirty = paths.filter(isTabCloseProtected);
  if (!dirty.length) return true;
  if (!window.confirm('Há alterações não salvas. Fechar e descartar essas alterações?')) return false;
  for (const path of dirty) guards.get(path)?.onDiscard?.();
  return true;
}
